import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,
	Input,	
} from 'reactstrap';

import {
   allStudents,
   fetchTournamentProcessReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';



class tournamentreport extends Component {
   
   constructor(props) {
      
      super(props);

         this.state = {
            student:'',
            startdate:'',
            enddate:'',
            viewdiv1:true,
            viewdiv2:false,
            viewdiv3:false,
            loader:false,  
            selround:[],
            allcourse:[],
            filappy:0,
          
         };  
 
         
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
   }  

   UNSAFE_componentWillMount() {
	   this.props.allStudents();
	} 

   selstudent(evt){
        var student=evt.value;
        var stdate='';
        var eddate='';
        var tournament='';
        var round='';
        this.setState({ 
            loader:true,
            student: student, 
            startdate:'',
            enddate:'', 
            selround:[],
            allcourse:[],
            viewdiv2:false,
            viewdiv3:false,
            filappy:0,
        });

        this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round).then((data) => {   
            this.setState({ 
                loader:false,
                viewdiv2:true, 
                viewdiv3:true, 
            });

        });
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');      
        var round="";
        var tournament="";
        this.setState({ 
            selround:[],
            allcourse:[],
            loader:true,
            viewdiv2:false,
            viewdiv3:false,
            filappy:0,
        });

        this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round).then((data) => {   
            this.setState({ 
                loader:false,
                viewdiv2:true,
                viewdiv3:true,
            });

        });
        
        
    } 


    
    handleChange(event, id){ 
        if(id==1){
            if(event.length==0){
                this.setState({ 
                    selround:[]
                });
            }else{
                var allsel=[];
                event.map((stdval) => { 
                    allsel.push(stdval.value);
                });   
                this.setState({ 
                    selround:allsel
                });
            }    
        }else if(id==2){
            if(event.length==0){
                this.setState({ 
                    allcourse:[]
                });
            }else{
                var allsel=[];
                event.map((stdval) => { 
                    allsel.push(stdval.value);
                });   
                this.setState({ 
                    allcourse:allsel
                });
            }    
        }        
    }
    
    filterSubmit(){
        var student=this.state.student;
        if(this.state.startdate==""){
            var stdate="";
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }

        if(this.state.enddate==""){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        var allround=this.state.selround;
        var alltournament=this.state.allcourse;
        if(allround.length==0){
            var round="";
        }else{
            var round=allround.join(',');
        }

        if(alltournament.length==0){
            var tournament="";
        }else{
            var tournament=alltournament.join(',');
        } 

        this.setState({ 
            loader:true,
            viewdiv3:false,
            filappy:1,
        });

        this.props.fetchTournamentProcessReport(student, stdate, eddate, tournament, round).then((data) => {   
            this.setState({ 
                loader:false,
                viewdiv3:true,
            });

        });
    }

     

    render() {
      const { match, studentlists, tournamentprocessreport, loading } = this.props;

        const allstudent=studentlists.map((stdval) => {  
            return {
                label: stdval.student,  
                value: stdval.uudID
            }
        });
        const reportlength=tournamentprocessreport.length;
        if(reportlength==0){
            var alltournament=[];
        }else{
            var fetchtour=tournamentprocessreport.tournament;
            var alltournament=fetchtour.map((trnval) => {  
                return {
                    label: trnval.tournament,  
                    value: trnval.gtlID
                }
            });  
        } 
        const allround=[
            {
                label: "Round 1",  
                value: 1
            },
            {
                label: "Round 2",  
                value: 2
            },
            {
                label: "Round 3",  
                value: 3
            },
            {
                label: "Round 4",  
                value: 4
            }
        ];     
        
        const styles = {
            table: {
                border: "2px solid rgb(0, 0, 0)",
                borderColor:"rgb(0 0 0 / 49%)",
                borderStyle:"solid",
                color:"#000"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                fontWeight: "500"
            },
            tabletrtdleft:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px"
            },
            tabletrtdhead:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                fontWeight:"bold",
                textAlign:"center"
            }
        };

        
        return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Tournament Process Report  | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tournamentprocessreport" />} match={match} />
             <div className="row" >
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">      
                                            <div className="col-lg-4">
                                            <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                            </FormGroup>
                                            </div>                                              
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>

               

                {this.state.viewdiv2 &&
                  <> 
                    {this.state.filappy==0&&reportlength==0 ?
                        <div className="col-sm-12 col-lg-12">
                            <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                        </div>
                    :
                        <div className="row">
                            
                            <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                                          
                            <RctCollapsibleCard>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                        <FormGroup>
                                            <Label for="Select">Tournament *</Label>
                                            <Selectsearch isMulti  id="tournament" name="tournament" defaultValue={this.state.allcourse} placeholder="Select Tournament" options={alltournament} onChange={e =>this.handleChange(e, 2)} required/>
                                        </FormGroup>
                                    </div>    
                                    <div className="col-sm-12 col-lg-4">
                                        <FormGroup>
                                            <Label for="Select">Round *</Label>
                                            <Selectsearch isMulti  id="round" name="round" defaultValue={this.state.selround} placeholder="Select Round" options={allround} onChange={e =>this.handleChange(e, 1)} required/>
                                        </FormGroup>
                                        </div>    
                                    <div className="col-sm-12 col-lg-2">    
                                        <div className="form-group">                       
                                            <button className="btn btn-outline-primary float-right" onClick={this.filterSubmit} >Filter</button>                                            
                                        </div>
                                    </div>
                                </div>
                                {this.state.viewdiv3 &&
                                   <> 
                                   {this.state.filappy==1&&reportlength==0 ?
                                       <div className="col-sm-12 col-lg-12">
                                           <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                                       </div>
                                   :
                                    <div className={tournamentprocessreport.total==1? "col-sm-12  col-lg-12" : "col-sm-12  col-lg-6"} style={{margin:"0 auto"}}>
                                    <div className="table-responsive">
                                        <table className="table align-items-center table-flush" style={styles.table}>                        
                                            <tbody>
                                                <tr>
                                                <td style={styles.tabletrtdhead}>SHOT</td>
                                                <td style={styles.tabletrtdhead}>SUCCESS RATE</td>
                                                {tournamentprocessreport.total==1? <td style={styles.tabletrtdhead}>NOTES</td> :""}
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>DRIVING</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.driving+'%'}</strong></td>
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.drvnotes}</td> :""}                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>FWAY WOODS</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.fwaywood+'%'}</strong></td>
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.fwynotes}</td> :""}                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>APPROACH SHOTS</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.approach+'%'}</strong></td> 
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.apprnotes}</td> :""}                                               
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>WEDGE PLAY</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.wedge+'%'}</strong></td>  
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.wedgenotes}</td> :""}                                              
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>BUNKER PLAY</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.bunker+'%'}</strong></td> 
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.bunkernotes}</td> :""}                                               
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>CHIPPING</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.chipping+'%'}</strong></td> 
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.chipnotes}</td> :""}                                               
                                                </tr>                                                
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>SPECIALITY</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.speciality+'%'}</strong></td> 
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.spsnotes}</td> :""}                                               
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabletrtdleft}>PUTTING</td>
                                                    <td style={styles.tabletrtd}><strong>{tournamentprocessreport.putting+'%'}</strong></td> 
                                                    {tournamentprocessreport.total==1? <td style={styles.tabletrtd}>{tournamentprocessreport.putnotes}</td> :""}                                               
                                                </tr>                                                
                                            </tbody>
                                        </table>    
                                    </div>
                                    </div> 
                                    }
                                    </>        
                                }   
                            </RctCollapsibleCard> 
                            </div>
                            
                        </div>
                    }
                   </> 
                }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

                               
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, tournamentprocess }) => {
	const { studentlists, loading } = mostlyused;
    const { tournamentprocessreport } = tournamentprocess;
	return { studentlists, tournamentprocessreport, loading };
}

export default connect(mapStateToProps, {
   allStudents,
   fetchTournamentProcessReport,
})(tournamentreport); 